export default __webpack_public_path__ + "resources/icons/d211-b258.png";